import React from 'react';
import PropTypes from 'prop-types';
import { Button as StyleguideButton } from '@zocdoc/components/src/button';
import { breakpoint, HideFor, ShowFor } from '@zocdoc/components/src/grid';
import styled from 'styled-components';
import { white } from '@zocdoc/branding/colors';

const WhiteButton = styled(StyleguideButton)`
    color: ${white};
    border-color: ${white};

    &:hover {
        border-color: ${white};
    }
`;

const ButtonContainer = styled.div`
    ${breakpoint.xxsmall} {
        width: 100%;
    }
    ${breakpoint.small} {
        width: auto;
    }
`;

export default function Button({ children, href, trackListPracticeClick }) {
    return (
        <ButtonContainer>
            <ShowFor
                xsmall
                xxsmall
            >
                <WhiteButton
                    beforeClick={trackListPracticeClick}
                    data-test="list-practice-button-xxsmall"
                    fluid
                    href={href}
                    style={StyleguideButton.STYLE.TRANSPARENT}
                >
                    {children}
                </WhiteButton>
            </ShowFor>
            <HideFor
                xsmall
                xxsmall
            >
                <StyleguideButton
                    beforeClick={trackListPracticeClick}
                    data-test="list-practice-button"
                    href={href}
                    style={StyleguideButton.STYLE.PRIMARY}
                >
                    {children}
                </StyleguideButton>
            </HideFor>
        </ButtonContainer>
    );
}

Button.propTypes = {
    children: PropTypes.node.isRequired,
    href: PropTypes.string.isRequired,
    trackListPracticeClick: PropTypes.func.isRequired,
};
